import { Link, useLocation } from "react-router-dom";
import { Logo } from "@/components/common/Logo";
import { ThemeToggle } from "@/components/common/ThemeToggle";
import { Images, ScanFace, Heart, Send, Loader2 } from "lucide-react";

export function ClientNav({ eventId, eventName }) {
  const { pathname } = useLocation();
  const links = [
    { to: `/event/${eventId}/find`, label: "Find My Photos", icon: ScanFace },
    { to: `/event/${eventId}/gallery`, label: "All Photos", icon: Images },
    { to: `/event/${eventId}/selected`, label: "My Selection", icon: Heart },
  ];
  return (
    <header className="sticky top-0 z-40 glass-cream border-b border-maroon/10">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 py-3 flex items-center justify-between gap-3">
        <div className="flex items-center gap-2 min-w-0">
          <Logo compact />
          <span className="text-sm text-ink font-medium truncate hidden sm:block">{eventName}</span>
        </div>
        <nav className="flex items-center gap-1 sm:gap-2">
          {links.map((l) => {
            const active = pathname === l.to;
            return (
              <Link key={l.to} to={l.to} data-testid={`clientnav-${l.label.replace(/\s/g, "-").toLowerCase()}`}
                className={`flex items-center gap-1.5 rounded-full px-3 sm:px-4 py-2 text-xs sm:text-sm transition-colors ${active ? "bg-maroon text-cream" : "text-ink/70 hover:text-maroon hover:bg-maroon/5"}`}>
                <l.icon className="w-4 h-4" /> <span className="hidden sm:inline">{l.label}</span>
              </Link>
            );
          })}
          <ThemeToggle className="!w-9 !h-9 ml-1" />
        </nav>
      </div>
    </header>
  );
}

export function SubmitBar({ count, onSubmit, submitting, label = "Submit Selection" }) {
  if (count === 0) return null;
  return (
    <div className="fixed bottom-4 inset-x-0 z-50 flex justify-center px-4">
      <div className="bg-white shadow-xl shadow-maroon/15 border border-maroon/10 rounded-full pl-6 pr-2 py-2 flex items-center gap-4" data-testid="submit-bar">
        <span className="text-sm text-ink"><span className="text-maroon font-medium">{count}</span> photo{count !== 1 ? "s" : ""} selected</span>
        <button data-testid="submit-selection" onClick={onSubmit} disabled={submitting}
          className="inline-flex items-center gap-2 bg-maroon text-cream text-sm font-medium rounded-full px-5 py-2.5 hover:bg-maroon-dark transition-colors disabled:opacity-60">
          {submitting ? <Loader2 className="w-4 h-4 animate-spin" /> : <Send className="w-4 h-4" />} {label}
        </button>
      </div>
    </div>
  );
}
